import request from '@/utils/request'

// 引入
// import touristApi from '@/api/system/tourist/tourist.js'

// 使用
// touristApi.houseCustomTagList().then((res) => {
//   if (res.code == 200) {
//     this.$message.success('查询房源自定义标签列表')
//     this.customTagList = res.data
//   }
// })

export default {

  // 新增客源需求信息
  touristAdd(data) {
    // console.log(data, '客源');
    return request({
      url: '/houses/lesseeRequirementSale',
      method: 'post',
      data: data
    })
  },
  // 修改客源需求信息
  touristPut(data) {
    return request({
      url: '/houses/lesseeRequirementSale',
      method: 'put',
      data: data
    })
  },
  // 获取客源详情信息
  touristDetails(id) {
    return request({
      url: `/houses/lesseeRequirementSale/${id}`,
      method: 'get'
    })
  },
  // 查询客源需求列表
  lesseeRequirementList(query) {
    // console.log('查询客源需求列表', query);
    return request({
      url: '/houses/lesseeRequirementSale/list',
      method: 'get',
      params: query
    })
  },
  // 转维护人
  toMaintainer(data) {
    return request({
      url: '/houses/lesseeRequirementSale/update/accendant',
      method: 'put',
      data: data
    })
  },
  // 修改客源需求信息标识（1：五，3：优，5:意向，6:暂缓）
  editIdentity(data) {
    return request({
      url: '/houses/lesseeRequirementSale/update/identity',
      method: 'put',
      data: data
    })
  },

  // 点亮-取消点亮意向
  identityWill(data) {
    return request({
      url: '/houses/lesseeRequirementSale/update/will',
      method: 'put',
      data: data
    })
  },

  // 查询房源信息列表
  gethouseInfoList(query) {
    return request({
      url: `/houses/houseInfoSale/list`,
      method: 'get',
      params: query

    })
  },

  // 客源一键同步
  synchronization(data) {
    return request({
      url: '/houses/lesseeRequirementSale/edit/synchronization',
      method: 'put',
      data: data
    })
  },





  //详情-历史成交-----------------------------------------------

  // 查询合同信息列表
  contractsInfo(query) {
    return request({
      url: `/contractsInfo/list`,
      method: 'get',
      params: query
    })
  },

}


